class HeadersModel {
}
var HTTPMethod;
(function (HTTPMethod) {
    HTTPMethod[HTTPMethod["get"] = 0] = "get";
    HTTPMethod[HTTPMethod["post"] = 1] = "post";
    HTTPMethod[HTTPMethod["delete"] = 2] = "delete";
    HTTPMethod[HTTPMethod["put"] = 3] = "put";
    HTTPMethod[HTTPMethod["patch"] = 4] = "patch";
})(HTTPMethod || (HTTPMethod = {}));
function aggregatorUrl(api) {
    return (endpoint) => (apiUrlSettings) => (...params) => {
        const searchParams = new URLSearchParams();
        if (params.length) {
            searchParams.set("id", api.endpoints[endpoint].getRemoteURL(...params));
            if (apiUrlSettings) {
                searchParams.set("variables", JSON.stringify({
                    realm: apiUrlSettings.realm,
                    territory: apiUrlSettings.territory,
                    language: apiUrlSettings.language,
                    itemNumber: params[2],
                }));
            }
        }
        const queryString = searchParams.toString();
        const configUrl = queryString ? `?${queryString}` : "";
        return `${api.baseURL}${decodeURIComponent(configUrl)}`;
    };
}
function apiURL(api, realmOnly) {
    return (endpoint) => (apiUrlSettings) => (...params) => {
        let configUrl = "";
        if (apiUrlSettings) {
            if (realmOnly) {
                configUrl = `/${apiUrlSettings.realm}`;
            }
            else {
                configUrl = `/${apiUrlSettings.realm}/${apiUrlSettings.territory}/${apiUrlSettings.language}`;
            }
        }
        return `${api.baseURL}${configUrl}/${api.version}${api.endpoints[endpoint].getRemoteURL(...params)}`;
    };
}
function apiMethod(api) {
    return (endpoint) => HTTPMethod[api.endpoints[endpoint].method];
}
function localEndpoint(api) {
    return (endpoint) => (...params) => api.endpoints[endpoint].getLocalURL(...params);
}
function routeDefinition(api) {
    return (endpoint) => api.endpoints[endpoint].routeDefinition;
}
function buildExport(api, endpoint, realmOnly) {
    return {
        url: apiURL(api, realmOnly)(endpoint),
        aggregatorUrl: aggregatorUrl(api)(endpoint),
        method: apiMethod(api)(endpoint),
        localEndpoint: api.endpoints[endpoint].getLocalURL ? localEndpoint(api)(endpoint) : null,
        routeDefinition: api.endpoints[endpoint].getLocalURL ? routeDefinition(api)(endpoint) : null,
    };
}

export { HTTPMethod, HeadersModel, aggregatorUrl, apiMethod, apiURL, buildExport, localEndpoint, routeDefinition };
